export const monospaceFontFamily = "Monaco, monospace";
